// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autovoting-page {
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
  color: var(--text-primary);
}

.autovoting-header {
  margin-bottom: 24px;
}

.autovoting-header h1 {
  font-size: 1.5rem;
  margin: 0 0 8px 0;
}

.autovoting-header p {
  color: var(--text-secondary);
  margin: 0;
}

.av-section {
  background: var(--bg-surface);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.av-section h2 {
  font-size: 1.2rem;
  margin-top: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 8px;
}

/* Form Styles */
.av-form-group {
  margin-bottom: 16px;
}

.av-form-group label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 6px;
}

.av-form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.av-form-control:focus {
  outline: none;
  border-color: var(--primary-color);
}

.av-form-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-end;
}

.av-form-row > * {
  flex: 1 1;
  min-width: 120px;
}

.av-checkbox-label {
  display: flex !important;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.av-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
}

.av-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.av-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.av-btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.av-btn-danger {
  background-color: #dc3545;
  color: white;
}

.av-btn-warning {
  background-color: #fd7e14;
  color: white;
}

/* Rules List */
.av-rules-table {
  width: 100%;
  border-collapse: collapse;
}

.av-rules-table th,
.av-rules-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.av-rules-table th {
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.av-rules-table tr:last-child td {
  border-bottom: none;
}

.av-empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-secondary);
}

/* User Search specifically for Autovoting */
.av-search-container {
  position: relative;
}

.av-search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.av-search-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
}

.av-search-item:hover {
  background: var(--bg-hover);
}

.av-search-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}

/* Toggle type buttons */
.av-type-toggles {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.av-type-btn {
  padding: 6px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.av-type-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.av-pause-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 118px;
  height: 30px;
  padding: 4px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: var(--bg-tertiary, #2c2c2c);
  cursor: pointer;
}

.av-pause-option {
  z-index: 2;
  flex: 1 1;
  text-align: center;
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--text-secondary);
  padding: 4px 8px;
}

.av-pause-option.active {
  color: var(--text-primary);
}

.av-pause-slider {
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(50% - 3px);
  height: calc(100% - 6px);
  background: var(--bg-primary, #1e1e1e);
  border-radius: 999px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.av-pause-toggle.on .av-pause-slider {
  transform: translateX(100%);
}

/* History Pagination Selector */
.history-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px;
}

.history-selector-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.history-selector-label {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.history-selector-input {
  width: 80px;
  padding: 4px 8px;
}

.history-selector-total {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.history-selector-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.history-page-btn {
  padding: 4px 12px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.history-selector-page-info {
  font-size: 0.9rem;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.history-page-input {
  width: 60px;
  padding: 4px 8px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Autovoting.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;EACpB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".autovoting-page {\n  padding: 24px;\n  max-width: 900px;\n  margin: 0 auto;\n  color: var(--text-primary);\n}\n\n.autovoting-header {\n  margin-bottom: 24px;\n}\n\n.autovoting-header h1 {\n  font-size: 1.5rem;\n  margin: 0 0 8px 0;\n}\n\n.autovoting-header p {\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.av-section {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.av-section h2 {\n  font-size: 1.2rem;\n  margin-top: 0;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 8px;\n}\n\n/* Form Styles */\n.av-form-group {\n  margin-bottom: 16px;\n}\n\n.av-form-group label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.av-form-control {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.av-form-control:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.av-form-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.av-form-row > * {\n  flex: 1;\n  min-width: 120px;\n}\n\n.av-checkbox-label {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.av-btn {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.2s;\n}\n\n.av-btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.av-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.av-btn-primary {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.av-btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.av-btn-warning {\n  background-color: #fd7e14;\n  color: white;\n}\n\n/* Rules List */\n.av-rules-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.av-rules-table th,\n.av-rules-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.av-rules-table th {\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.av-rules-table tr:last-child td {\n  border-bottom: none;\n}\n\n.av-empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--text-secondary);\n}\n\n/* User Search specifically for Autovoting */\n.av-search-container {\n  position: relative;\n}\n\n.av-search-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  margin-top: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.av-search-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.av-search-item:hover {\n  background: var(--bg-hover);\n}\n\n.av-search-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n/* Toggle type buttons */\n.av-type-toggles {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.av-type-btn {\n  padding: 6px 16px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.av-type-btn.active {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.av-pause-toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-width: 118px;\n  height: 30px;\n  padding: 4px;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  background: var(--bg-tertiary, #2c2c2c);\n  cursor: pointer;\n}\n\n.av-pause-option {\n  z-index: 2;\n  flex: 1;\n  text-align: center;\n  font-size: 0.74rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  padding: 4px 8px;\n}\n\n.av-pause-option.active {\n  color: var(--text-primary);\n}\n\n.av-pause-slider {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: calc(50% - 3px);\n  height: calc(100% - 6px);\n  background: var(--bg-primary, #1e1e1e);\n  border-radius: 999px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  transition: transform 0.2s ease;\n}\n\n.av-pause-toggle.on .av-pause-slider {\n  transform: translateX(100%);\n}\n\n/* History Pagination Selector */\n.history-selector {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 16px;\n}\n\n.history-selector-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.history-selector-label {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.history-selector-input {\n  width: 80px;\n  padding: 4px 8px;\n}\n\n.history-selector-total {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.history-selector-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.history-page-btn {\n  padding: 4px 12px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.history-selector-page-info {\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.history-page-input {\n  width: 60px;\n  padding: 4px 8px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
